export default __webpack_public_path__ + "static/media/logo.2fec56c5.png";